import { FC, Fragment, useState, useEffect } from 'react';
import Link from 'next/link';
import { parseISO, format } from 'date-fns';
import { getAuthorFullName } from '@/helpers/helpers';
import BookCardImg from '../book-card-img/BookCardImg';
import BtnReadOnline from '../btn-read-online/BtnReadOnline';
import SocialsBar from '../socials-bar/SocialsBar';
// import RatingStars from '../book-info/rating-stars/RatingStars';
// import LitresWidget from '@/components/ui/litres-widget/LitresWidget';
// import BtnReadOnline from '../btn-read-online/BtnReadOnline';
// import BtnsReviewQuote from '../btns-review-quote/BtnsReviewQuote';
// import BookRatingJsonMarkup from '../book-rating-json-markup/BookRatingJsonMarkup';
import { getLanguage } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IPodcastsDetailData, IPodcastsDetailAuthor, IPodcastsDetailGenre } from '@/interfaces/podcastsDetail.interface';
import { IPodcastDetail } from '@/interfaces/podcastDetail.interface';
import styles from './../book-info/BookInfo.module.scss';

interface IAllPodcasts extends IPodcastDetail, IPodcastsDetailData {}

interface IBookInfoPodcast {
  book: IAllPodcasts;
  isPodcast?: boolean;
  isPodcastsFree?: boolean;
}

const BookInfoPodcast: FC<IBookInfoPodcast> = ({ book, isPodcast, isPodcastsFree }) => {
  const { genres, rating, id } = book;
  const { first_name, middle_name, last_name } = book.authors[0];

  const externalId = isPodcast ? book.podcast_item.external_id : book.external_id;
  const title = isPodcast ? book.podcast_item.title : book.title;

  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  });

  const getBookInfoRows = () => {
    return (
      <>
        <div className={styles.bookInfo__row}>
          <b>Автор: </b>

          {book.authors !== undefined &&
            book.authors.map((author: IPodcastsDetailAuthor) => {
              return (
                <Fragment key={author.alias}>
                  <span key={author.alias}>{getAuthorFullName(author.first_name, author.middle_name, author.last_name)}</span>{' '}
                </Fragment>
              );
            })}
        </div>
        <div className={styles.bookInfo__row}>
          <b>Название: </b>
          {title}
        </div>

        {isPodcast && (
          <div className={styles.bookInfo__row}>
            <b>Подкаст: </b>
            <Link prefetch={false} className={styles.bookInfo__categoryLink} href={`/lib/podcasts/id${book.id}`}>
              {book.podcast.title}
            </Link>
          </div>
        )}

        <div className={styles.bookInfo__row}>
          <b>Жанр: </b>
          {genres.map((genre, i: number) => (
            <span key={genre.id}>
              {' '}
              <Link prefetch={false} className={styles.bookInfo__rowLink} href={`/genre/${genre.alias}`}>
                {genre.title}
              </Link>
              {i < genres.length - 1 ? ',' : ''}
            </span>
          ))}
        </div>

        <div className={styles.bookInfo__row}>
          <b>Язык: </b>
          {isPodcast ? getLanguage(book.podcast.lang) : getLanguage(book.lang)}
        </div>
        <div className={styles.bookInfo__row}>
          <b>Возрастное ограничение: </b>
          {isPodcast ? book.podcast.adult : book.adult}
        </div>

        {!isPodcast && (
          <div className={styles.bookInfo__row}>
            <b>Доступно: </b>
            {book.items.length} выпусков
          </div>
        )}
        {isPodcast && (
          <div className={styles.bookInfo__row}>
            <b>Длительность: </b>10 мин.
          </div>
        )}

        <div className={styles.bookInfo__row}>
          <b>Последнее обновление: </b>
          {isPodcast ? <time dateTime={book.podcast_item.updated_at}>{format(parseISO(book.podcast_item.updated_at), 'dd.MM.yyyy')}</time> : <time dateTime={book.created_at}>{format(parseISO(book.created_at), 'dd.MM.yyyy')}</time>}
        </div>
        <div className={styles.bookInfo__row}>
          <b>Добавлен: </b>
          {isPodcast ? <time dateTime={book.podcast_item.created_at}>{format(parseISO(book.podcast_item.created_at), 'dd.MM.yyyy')}</time> : <time dateTime={book.updated_at}>{format(parseISO(book.updated_at), 'dd.MM.yyyy')}</time>}
        </div>
      </>
    );
  };

  return (
    <>
      {/* {!!genres.length && book.rating > 0 && <BookRatingJsonMarkup book={book} authorFullName={authorFullName} />} */}
      <h1 className={styles.bookInfoTitle}>{`Подкаст ${title}`}</h1>

      <div className={styles.bookInfo}>
        <div className={styles.bookInfo__imageWrap}>
          <div className={styles.bookInfo__img}>
            <BookCardImg coverId={externalId} title={title} bookId={id} isPodcast />
          </div>
          {/* <div className={styles.bookInfo__imgDesс}>
            <div className={`${styles.bookInfo__rows} ${styles.bookInfo__rows_mob}`}>{getBookInfoRows()}</div>
            <RatingStars rating={rating} title={title} id={book.id} />
            <BtnsReviewQuote reviewLink="#bookReviewForm" />
          </div> */}
          <SocialsBar bookLink={`/lib/podcasts/id${book.id}`} />
        </div>

        <div className={styles.bookInfo__desc}>
          <div className={!isPodcast && isPodcastsFree ? `${styles.bookInfo__podcastsRows} ${styles.bookInfo__podcastsRows_marginBottomNone}` : `${styles.bookInfo__podcastsRows}`}>{getBookInfoRows()}</div>

          {isPodcast && isPodcastsFree && (
            <div className={`${styles.bookInfo__audioPlayer} ${styles.bookInfo__audioPlayer_marginNone}`} id="audioPlayer">
              <h3 className={styles.litresWidget__title}>Слушать онлайн</h3>
              <audio controls>
                <source src={`${DEV_ABSOLUTE_URL}/api/v1/satellite/podcast/get-file?podcast_item_external_id=${book.podcast_item.external_id}`} type="audio/mpeg" />
              </audio>
            </div>
          )}

          {isClient && !isPodcastsFree && (
            <div className={styles.bookInfo__btn}>
              <BtnReadOnline name="Купить и скачать" target="_blank" alias={`https://www.litres.ru/pages/biblio_book/?art=${isPodcast ? book.podcast_item.external_id : book.external_id}`} />
            </div>
          )}
        </div>
      </div>

      <div className={styles.b_biblio_book_line}>
        <span className={`${styles.added} ${styles.bolder_r}`}>
          <span className={styles.posted}>
            Добавленo:
            {isPodcast ? <time dateTime={book.podcast_item.created_at}>{format(parseISO(book.podcast_item.created_at), 'dd.MM.yyyy')}</time> : <time dateTime={book.created_at}>{format(parseISO(book.created_at), 'dd.MM.yyyy')}</time>}
          </span>
        </span>

        <span className={styles.rating}>Рейтинг: {rating > 0 ? rating : 'Будь первым, кто оценит книгу'} </span>

        {/* <span className={styles.comments}>
          <Link prefetch={false} href={`#bookReviewForm`}>
            Комментариев {!!reviewsCount ? reviewsCount : '0'} шт.
          </Link>
        </span> */}
      </div>
    </>
  );
};

export default BookInfoPodcast;
